module.exports = __webpack_public_path__ + "img/Linkedin.fd0d5546.png";